module.exports = __webpack_public_path__ + "img/page-02.caa3e3e1.jpg";